const styles = theme => ({
  root: {
    // marginTop: theme.fontSize,
    // marginBottom: theme.fontSize,
    // marginRight: theme.fontSize * 2,
    marginLeft: 0,
  },
  ul: {
    listStyle: 'none',
    padding: '0 10px',
    margin: 0,
    zIndex: 10000,
  },
  li: {
    // margin: `0 -${theme.fontSize}px`,
    // padding: `5px ${theme.fontSize}px`,
    padding: '6px 0',
    whiteSpace: 'break-spaces',
    cursor: 'pointer',
    // transition: 'background-color 0.1s ease-in-out',
    // '&:hover': {
    //   backgroundColor: '#ebebeb',
    // },
  },
  title: {
    fontSize: theme.fontSize,
    color: theme.qlikGreen,
    marginBottom: 10,
    paddingBottom: 10,
    fontWeight: 'bold',
    borderBottom: '1px solid #D4D4D4',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'spaceBetween',
  },
  subTitle: {
    color: '#afafaf',
    fontSize: '12px',
    fontStyle: 'italic',
    fontWeight: 'normal',
    textTransform: 'capitalize',
  },
  selected: {
    background: theme.qlikGreen,
    color: '#fff',
  },
  excluded: {
    background: '#ccc',
  },
});

export default styles;
